import { useLocation } from "react-router-dom";

import { IAdminRouteGroup } from "../../../@types/AdminRoute";
import { ChevronDown } from "../../../assets/icons/ChevronDown";
import { AdminMenuItem } from "./AdminMenuItem";
import {
  StyledAccordionItem,
  StyledAccordionHeader,
  StyledAccordionTrigger,
  StyledAccordionContent,
  IconContainer,
  MenuItemText,
  ChevronIcon,
  ChildMenuList,
} from "./AdminSidebar.styles";

interface IAdminMenuGroupProps {
  group: IAdminRouteGroup;
}

export function AdminMenuGroup({ group }: IAdminMenuGroupProps) {
  const location = useLocation();
  const { name, Icon, children } = group;

  const isGroupActive = children?.some(
    (child) => location.pathname === child.path
  );

  return (
    <StyledAccordionItem value={name}>
      <StyledAccordionHeader>
        <StyledAccordionTrigger active={isGroupActive}>
          <IconContainer>
            <Icon width="22px" height="22px" />
          </IconContainer>
          <MenuItemText>{name}</MenuItemText>
          <ChevronIcon>
            <ChevronDown />
          </ChevronIcon>
        </StyledAccordionTrigger>
      </StyledAccordionHeader>

      <StyledAccordionContent>
        <ChildMenuList>
          {children?.map((child) => (
            <AdminMenuItem
              key={child.path}
              name={child.name}
              path={child.path}
              Icon={child.Icon}
              disabled={child.disabled}
              isChild
            />
          ))}
        </ChildMenuList>
      </StyledAccordionContent>
    </StyledAccordionItem>
  );
}
